import { type ChangeEvent, useEffect, useMemo, useState } from 'react';
import { type InputProps as StandardInputProps } from '@mui/material/Input/Input';
import debounce from 'lodash/debounce';

const waitDelay = 300;

type UseSearchParams = undefined | ((event: ChangeEvent<HTMLInputElement> | unknown, newPage: number) => void);
export const useSearch = (handleChangePage?: UseSearchParams) => {
  const [searchValue, setSearchValue] = useState('');

  const debouncedHandleSearch = useMemo(() => {
    const handleSearch: StandardInputProps['onChange'] = event => {
      const trimmedValue = event.target.value.trim();
      setSearchValue(trimmedValue);
      if (handleChangePage) {
        handleChangePage(undefined, 0);
      }
    };
    return debounce(handleSearch, waitDelay);
  }, [setSearchValue, handleChangePage]);

  useEffect(() => {
    return () => {
      debouncedHandleSearch.cancel();
    };
  });

  return {
    searchValue,
    handleSearch: debouncedHandleSearch
  };
};
